import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { UiV2Scope } from '@kawai/ui';
import { Layout } from './components/Layout.js';
import { HomePage } from './pages/HomePage.js';
import { SignInPage } from './pages/SignInPage.js';
import { BillingPage } from './pages/BillingPage.js';
import { NotificationRecipientsPage } from './pages/NotificationRecipientsPage.js';
import { ROUTES } from './routes.js';

/**
 * S-136: Layout（AppShell の <main>）の内側を `UiV2Scope` で包み、書体・字間・行間（`.ui-v2`）と
 * @kawai/ui の Button / Input / Modal の v2 既定をページ本体へ。左・上部メニューは対象外。
 */
function V2Scope() {
  return (
    <UiV2Scope>
      <Outlet />
    </UiV2Scope>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTES.signIn} element={<SignInPage />} />
        {/* S-90: 認可ガード + AppShell（ヘッダータブ / サイドバー）は Layout に集約 */}
        <Route element={<Layout />}>
          <Route element={<V2Scope />}>
            <Route path={ROUTES.home} element={<HomePage />} />
            <Route path={ROUTES.billing} element={<BillingPage />} />
            <Route
              path={ROUTES.notificationRecipients}
              element={<NotificationRecipientsPage />}
            />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
      </Routes>
    </BrowserRouter>
  );
}
